import React, { useState } from "react";

function BraidCarousel({ images, braidName }) {
  const [currentIndex, setCurrentIndex] = useState(0);

  if (!images || images.length === 0) {
    return null;
  }

  const previousImage = () => {
    setCurrentIndex((current) =>
      current === 0 ? images.length - 1 : current - 1
    );
  };

  const nextImage = () => {
    setCurrentIndex((current) =>
      current === images.length - 1 ? 0 : current + 1
    );
  };

  return (
    <div className="braid-carousel">
      <button
        type="button"
        onClick={previousImage}
        aria-label="Previous image"
        className="carousel-button previous"
      >
        ‹
      </button>

      <img
        src={images[currentIndex]}
        alt={`${braidName} ${currentIndex + 1}`}
        className="carousel-image"
      />

      <button
        type="button"
        onClick={nextImage}
        aria-label="Next image"
        className="carousel-button next"
      >
        ›
      </button>

      <div className="carousel-dots">
        {images.map((_, index) => (
          <button
            key={index}
            type="button"
            onClick={() => setCurrentIndex(index)}
            className={index === currentIndex ? "dot active" : "dot"}
            aria-label={`View image ${index + 1}`}
          />
        ))}
      </div>
    </div>
  );
}

export default BraidCarousel;